module.exports = __webpack_public_path__ + "img/SingleLineContent.75c42070.svg";